// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"689e8de1","239":"495930cc","732":"33d7b511"}[chunkId] + ".chunk.js";
};